import { ensureString } from 'ensure-string';

export function parseDT0(dt0) {
  dt0 = ensureString(dt0);

  let lines = dt0.split(/\r?\n/).filter((line) => line);
  let data = lines.map((line) => line.split('\t').map(parseFloat));

  /*
  column 0: IPH
  column 1: IPT
  column 2: %BR
  column 3: IPS
  column 4: BRC
  */

  const variables = {
    x: {
      data: data.map((row, index) => index + 1),
      units: '',
      label: 'Pellet ID',
    },
    a: {
      data: data.map((row) => row[0]),
      units: '',
      label: 'IPT',
    },
    y: {
      data: data.map((row) => row[1]),
      units: 'cN',
      label: 'IPH',
    },
    b: {
      data: data.map((row) => row[2]),
      units: '',
      label: 'BR',
    },
    c: {
      data: data.map((row) => row[3]),
      units: '',
      label: 'IPS',
    },
    d: {
      data: data.map((row) => row[4]),
      units: '',
      label: 'BRC',
    },
  };
  return variables;
}
